import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

const consumer = createApi({
    reducerPath: 'consumer',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getConsumers: builder.query({
            query: () => 'consumer/get',
        }),
        getOtp: builder.mutation({
            query: (param) => ({
                url: 'consumer/getOtp',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        searchCustomer: builder.mutation({
            query: (param) => ({
                url: 'consumer/searchCustomer',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        signUp: builder.mutation({
            query: (param) => ({
                url: 'consumer/signup',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getListConsumer: builder.mutation({
            query: (param) => ({
                url: 'consumer/getListConsumer',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getListQRLocation: builder.mutation({
            query: (param) => ({
                url: 'consumer/getListQRLocation',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getSalesProcess: builder.mutation({
            query: (param) => ({
                url: 'consumer/getSalesProcess',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getSalesProcessMonths: builder.mutation({
            query: (param) => ({
                url: 'consumer/getSalesProcessMonths',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getSalesProcessPartials: builder.mutation({
            query: (param) => ({
                url: 'consumer/getSalesProcessPartials',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getCRMDashboard: builder.mutation({
            query: (param) => ({
                url: 'consumer/getCRMDashboard',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getImportSMS: builder.mutation({
            query: (param) => ({
                url: 'consumer/getImportSMS',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        saveImportSMS: builder.mutation({
            query: (param) => ({
                url: 'consumer/saveImportSMS',
                method: 'POST',
                body: param,
            }),
        }),
        getSMSContent: builder.mutation({
            query: (param) => ({
                url: 'consumer/getSMSContent',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
    }),
});
export const { useGetConsumersQuery, useSearchCustomerMutation, useGetOtpMutation, useSignUpMutation
    , useGetListConsumerMutation, useGetListQRLocationMutation, useGetSalesProcessMutation
    , useGetSalesProcessMonthsMutation, useGetSalesProcessPartialsMutation, useGetCRMDashboardMutation
    , useGetImportSMSMutation, useSaveImportSMSMutation, useGetSMSContentMutation } = consumer;
export default consumer;